<template>
    <div class="news" id="news">
        <div class="mobiletopbox hidden-sm-and-up">
            <div class="mobiletopbox_top">
                <div class="navigation">
                    <div class="navigation_location"></div>
                    <div class="navigation_index" @click="goIndex">Home</div>
                    <div class="navigation_img"></div>
                    <div class="navigation_text">{{name=='news_en'?'News':name=='about_en'?'About Us':'Member Area'}}</div>
                    <div class="navigation_img"></div>
                    <div class="navigation_text">{{typeName}}</div>
                    <div class="navigation_img"></div>
                    <div class="navigation_text">Details</div>
                </div>
            </div>
            <div class="mobiletopbox_bottom" :class="isShowType?'mobiletopbox_bottom_active':''">
                <div class="mobile_type section">
                    <div class="mobile_type_text">
                        <div class="mobile_type_text_left" @click="handleShowType">Category</div>
                        <div class="mobile_type_text_right">
                            <img src="../assets/images/common/more.png" alt="">
                        </div>
                    </div>
                    <div class="mobile_type_box" v-if="isShowType">
                        <div class="mobile_type_box_item" 
                           @click="handleChangeType(item.id)"
                           :class="typeId==item.id?'mobile_type_box_item_active':''"
                           v-for="(item,i) in typeList" :key="i">
                           <div class="mobile_type_box_item_left"></div>
                           <div class="mobile_type_box_item_right">{{item.typeName}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="news_box section">
            <div class="news_left hidden-xs-only">
                <div class="news_left_box">
                    <div class="news_left_item"
                    @click="handleChangeType(item.id)"
                    :class="typeId==item.id?'news_left_item_active':''"
                    v-for="(item,i) in typeList" :key="i">
                        <div class="news_left_item_left">{{item.typeName}}</div>
                        <div class="news_left_item_right">
                            <img v-if="typeId==item.id" src="../assets/images/news/rightArrow_active.png" alt="">
                            <img v-else src="../assets/images/news/rightArrow.png" alt="">
                        </div>
                        <div class="news_left_item_line">
                            <img v-if="typeId==item.id" src="../assets/images/news/line_active.png" alt="">
                            <img v-else src="../assets/images/news/line_none.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="news_left_line">
                    <img src="../assets/images/news/news_left.png" alt="">
                </div>
            </div>
            <div class="news_right" v-loading="loading">
                <div class="news_right_top hidden-xs-only">
                    <div class="navigation">
                        <div class="navigation_location"></div>
                        <div class="navigation_text">Location：</div>
                        <div class="navigation_index" @click="goIndex">Home</div>
                        <div class="navigation_img"></div>
                        <div class="navigation_text">{{name=='news_en'?'News':name=='about_en'?'About Us':'Member Area'}}</div>
                        <div class="navigation_img"></div>
                        <div class="navigation_text">{{typeName}}</div>
                        <div class="navigation_img"></div>
                        <div class="navigation_text">Details</div>
                    </div>
                </div>
                <div class="news_right_bottom">
                    <div class="news_right_bottom_box">
                        <div class="details_content">
                            <div class="details_title">
                                <div class="details_title_top">{{ detailsContent.title }}</div>
                                <div class="details_title_bottom">
                                    <div class="details_title_bottom_left">
                                        PublishTime：
                                        <span>{{detailsContent.publishTime?handleTime(detailsContent.publishTime):""}}</span>
                                    </div>
                                    <div class="details_title_bottom_line"></div>
                                    <div class="details_title_bottom_right">
                                        BrowseCount：{{detailsContent.browseCount?detailsContent.browseCount:0}}
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                            <div class="common_artical" v-if="detailsContent.content">
                                <div v-html="detailsContent.content"></div>
                            </div>
                            <div class="file" v-if="detailsContent.newsFileList && detailsContent.newsFileList.length > 0">
                                <div class="file_box">
                                    <div class="file_left">Files：</div>
                                    <div class="file_right">
                                        <div class="file_right_item" v-for="(item, i) in detailsContent.newsFileList" :key="i">
                                            <a :href="baseUrl + item.fileUrl">{{ item.fileName }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="details_content_other">
                            <div class="details_content_other_left">
                                <div class="details_content_other_left_item">
                                    Prev：
                                    <span v-if="prevDetail&&prevDetail.title" @click="handlePrev(prevDetail)">{{prevDetail.title}}</span>
                                </div>
                                <div class="details_content_other_left_item">
                                    Next：
                                    <span v-if="nextDetail&&nextDetail.title" @click="handlePrev(nextDetail)">{{nextDetail.title}}</span>
                                </div>
                            </div>
                            <div class="details_content_other_right" @click="goBack">
                                <div class="details_content_other_right_img">
                                    <img src="../assets/images/common/back_list.png" alt="">
                                </div>
                                <div class="details_content_other_right_text">Back</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { newsTypeList, newsList,newsDetails,newsBrowse } from '../untils/common-api.js'
export default {
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_URL,
            loading: false,
            name: this.$route.params.name,
            typeId:this.$route.params.type,
            typeName:'',
            id: this.$route.params.id,
            current:this.$route.params.current,
            typeList: [],
            query: {
                current: 1,
                pageSize: -1,
                newsType: this.$route.params.type,
                model:this.$route.params.name=='news_en'?2:this.$route.params.name=='about_en'?1:7,
                lang:2
            },
            newsList: [],
            detailsContent: '',
            prevDetail:{},
            nextDetail:{},

            isShowType:false

        }
    },
    created() {
        this.getNewsType()
        this.getDetails(this.id)
    },
    mounted() {
        this.getScrollTop()
    },
    methods:{
        /**
         * /details/:name/:type/:id/:current
         * /:name 指定列表路径
         * /:type 指定列表类型，获取列表名称
         * /:id   指定文章id
         * /:current   分页
         */
        async getNewsType() {
            let res = await newsTypeList(
                {
                    model:this.name=='news_en'?2:this.name=='about_en'?1:7,
                    lang:2
                }
            )
            if (res.code !== 1) return this.$message('Information retrieval failed. Please try again later')
            this.typeList = res.data.records
            if(this.typeList.length>0) {
                this.typeName = this.typeList.find(item => item.id == this.typeId).typeName
            }
            this.getNewsList()
        },
        // 获取新闻列表
        async getNewsList() {
            let res = await newsList(this.query)
            if (res.code !== 1) return this.$message('Information retrieval failed. Please try again later')
            this.newsList = res.data.records
            this.getOtherDetail()
        },
        getOtherDetail() {
            if(this.newsList.length>0) {
                // 通过id在列表中查找当前文章的索引
                let index = this.newsList.findIndex(item => item.id == this.id)
                // 如果索引为0，说明当前文章为第一篇，没有上一篇
                if (index == 0) {
                    this.prevDetail = {}
                } else {
                    this.prevDetail = this.newsList[index - 1]
                }
                // 如果索引为列表长度减1，说明当前文章为最后一篇，没有下一篇
                if (index == this.newsList.length - 1) {
                    this.nextDetail = {}
                } else {
                    this.nextDetail = this.newsList[index + 1]
                }
            }
        },
        handlePrev(item) {
            this.id = item.id
            this.getDetails(item.id)
            this.getOtherDetail()
            this.getScroll()
        },
        async getDetails(id) {
            this.loading = true // loading start
            let res = await newsDetails(id)
            this.loading = false // loading end
            if (res.code !== 1) return this.$message('Information retrieval failed. Please try again later')
            this.detailsContent = res.data
            this.getNewsBrowse(id)
        },
        async getNewsBrowse(id) {
            const res = await newsBrowse(id)
            if (res.code !== 1) return this.$message('Information retrieval failed. Please try again later')
        },
        // 更改类型
        handleChangeType(id) {
            window.location.href = '/#/'+this.name+'?type=' + id
            window.sessionStorage.setItem('scrollPosition', 0);
        },
        handleTime(time) {
            if(time) {
                let year = time.substring(0,4);
                let month = time.substring(5,7);
                let day = time.substring(8,10);
                let timeStr = year+'-'+month+'-'+day
                return timeStr;
            }
        },
        getScroll() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 600)
                }, 500);
            }
        },
        getScrollTop() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 0)
                }, 0);
            }
        },
        goIndex() {
            this.$router.push('/index_en')
        },
        goBack() {
            const scrollPosition = window.sessionStorage.getItem('scrollPosition');
            if (scrollPosition == '-1') {
                window.sessionStorage.setItem('scrollPosition', 0);
            }
            this.$router.push('/'+this.name+'?type=' + this.typeId + '&current='+this.current)
        },
        handleShowType() {
            this.isShowType = !this.isShowType
        }
    },
    beforeRouteLeave(to, from, next) {
        let arr = ['news_en','about_en','member_en']
        if(to.query&&to.query.type) {
            // 只有to.query.type存在才是返回上一页
            if (arr.indexOf(to.name) == -1) {
                window.sessionStorage.removeItem('scrollPosition');
            }
        } else {
            window.sessionStorage.removeItem('scrollPosition');
        }
        next();
    },
}
</script>
<style lang="less" scoped>
.news {
    background-color: #f6f9ff;
    padding: 30px 0 80px 0;
    .news_box {
        display: flex;
        .news_left {
            width: 288px;
            margin-right: 30px;
            position: relative;
            .news_left_box {
                padding: 24px 20px 20px 20px;
                background-color: #ffffff;
                .news_left_item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 18px;
                    padding: 0 20px 0 25px;
                    background-color: #F6F9FF;
                    margin-bottom: 10px;
                    height: 56px;
                    cursor: pointer;
                    position: relative;
                    .news_left_item_left {
                        width: calc(100% - 12px);
                    }
                    .news_left_item_right {
                        width: 12px;
                        img {
                            width: 12px;
                            height: 12px;
                        }
                    }
                    .news_left_item_line {
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        left: 0;
                        width: 6px;
                        height: 24px;
                        img {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 6px;
                            height: 24px;
                        }
                    }
                }
                .news_left_item_active {
                    background-color: #0085D0;
                    color: #ffffff;
                }
                .news_left_item:last-child {
                    margin-bottom: 0;
                }
            }
            .news_left_line {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 4px;
                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 4px;
                }
            }
        }
        .news_right {
            width: calc(100% - 288px - 30px);
            .news_right_top {
                border-bottom: 1px solid #E3E3E3;
            }
            .news_right_bottom {
                background-color: #ffffff;
                .news_right_bottom_box {
                    padding: 30px;
                    .details_content {
                        .details_title {
                            padding-bottom: 25px;
                            border-bottom: 1px dashed #DCDCDC;
                            .details_title_top {
                                font-size: 24px;
                                line-height: 36px;
                                font-weight: bold;
                                text-align: center;
                                margin-bottom: 20px;
                            }
                            .details_title_bottom {
                                font-size: 16px;
                                color: #787878;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                .details_title_bottom_left {
                                    span {
                                        color: #000000;
                                    }
                                }
                                .details_title_bottom_line {
                                    width: 1px;
                                    height: 15px;
                                    background-color: #000000;
                                    margin: 0 20px;
                                }
                                .details_title_bottom_right {
                                    span {
                                        color: #000000;
                                    }
                                }
                            }
                        }
                        .common_artical {
                            padding: 25px 0;
                            border-bottom: 1px dashed #DCDCDC;
                        }
                        .file {
                            padding: 25px 0;
                            border-bottom: 1px dashed #DCDCDC;
                            .file_box {
                                display: flex;
                                .file_left {
                                    width: 80px;
                                    font-size: 16px;
                                }
                                .file_right {
                                    width: calc(100% - 80px);
                                    .file_right_item {
                                        margin-bottom: 5px;
                                        a {
                                            font-size: 16px;
                                        }
                                    }
                                    .file_right_item:last-child {
                                        margin-bottom: 0;
                                    }
                                }
                            }
                        }
                    }
                    .details_content_other {
                        margin-top: 30px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .details_content_other_left {
                            width: calc(100% - 118px - 32px);
                            font-size: 16px;
                            color: #4B4B4B;
                            .details_content_other_left_item {
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                span {
                                    cursor: pointer;
                                }
                            }
                            .details_content_other_left_item:first-child {
                                margin-bottom: 20px;
                            }
                        }
                        .details_content_other_right {
                            width: 118px;
                            height: 72px;
                            background: #2277ec;
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                            align-items: center;
                            border-radius: 36px;
                            cursor: pointer;
                            .details_content_other_right_img {
                                img {
                                    width: 35px;
                                    height: 35px;
                                }
                            }
                            .details_content_other_right_text {
                                font-size: 16px;
                                color: #ffffff;
                            }
                        }
                    }
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .news {
        padding: .3rem 0 .6rem 0;
        .news_box {
            flex-direction: column;
            .news_right {
                width: 100%;
                padding-top: 0.2rem;
                .news_right_top {
                    border-bottom: 1px solid #E3E3E3;
                }
                .news_right_bottom {
                    background-color: #ffffff;
                    .news_right_bottom_box {
                        padding: 0.3rem 0.2rem;
                        .details_content {
                            .details_title {
                                padding-bottom: 0.3rem;
                                .details_title_top {
                                    font-size: 0.35rem;
                                    line-height: 1.5;
                                    margin-bottom: .2rem;
                                }
                                .details_title_bottom {
                                    font-size: 0.26rem;
                                    .details_title_bottom_line {
                                        width: 0.02rem;
                                        height: 0.28rem;
                                        margin: 0 0.2rem;
                                    }
                                }
                            }
                            .common_artical {
                                padding: 0.3rem 0;
                            }
                            .file {
                                padding: 0.3rem 0;
                                .file_box {
                                    .file_left {
                                        width: 1.4rem;
                                        font-size: 0.28rem;
                                    }
                                    .file_right {
                                        width: calc(100% - 1.4rem);
                                        .file_right_item {
                                            margin-bottom: 0.1rem;
                                            a {
                                                font-size: 0.28rem;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .details_content_other {
                            margin-top: .3rem;
                            .details_content_other_left {
                                width: calc(100% - 1.7rem - 0.2rem);
                                font-size: 0.28rem;
                                .details_content_other_left_item:first-child {
                                    margin-bottom: 0.15rem;
                                }
                            }
                            .details_content_other_right {
                                width: 1.7rem;
                                height: 1.1rem;
                                border-radius: 0.55rem;
                                .details_content_other_right_img {
                                    img {
                                        width: 0.5rem;
                                        height: 0.5rem;
                                    }
                                }
                                .details_content_other_right_text {
                                    font-size: 0.26rem;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>